export const PRODUCT_CATALOG_QUERY_CONFIG = {
  staleTime: 60 * 60 * 1000,
  cacheTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
};

export const PRODUCT_CATALOG_QUERY_KEY = 'getProductCatalog';
